import { Delete, FileDownloadOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import mime from 'mime';
import { useTheme } from 'styled-components';
import { ReactComponent as IconAdobe } from '../../assets/icons/icon-adobe.svg';
import { ReactComponent as IconAudio } from '../../assets/icons/icon-audio.svg';
import { ReactComponent as IconExcel } from '../../assets/icons/icon-excel.svg';
import { ReactComponent as IconImage } from '../../assets/icons/icon-image.svg';
import { ReactComponent as IconView } from '../../assets/icons/icon-view.svg';
import { ReactComponent as IconWord } from '../../assets/icons/icon-word.svg';
import { Download } from '../../controller/FileController';
import { Container, ItemAttachment, WrapperIcon } from './styles';
import { useApp } from '../../context';

export type IAttachment = {
  id?: string;
  name?: string;
  uri?: string;
  type?: string;
  file?: File;
};
type Props = {
  data?: IAttachment;
  onDelete?: () => void;
  options?: {
    disableDownload?: boolean;
    disableView?: boolean;
    disableDelete?: boolean;
  };
};

export function Attachment({ data, options, onDelete }: Props) {
  const theme = useTheme();
  const { setLoading } = useApp();
  const extension = mime.getExtension(data?.type ?? '');
  const getIcon = () => {
    if (extension === 'pdf') {
      return <IconAdobe />;
    }
    if (extension === 'doc' || extension === 'docx') {
      return <IconWord />;
    }
    if (extension === 'csv' || extension === 'xls' || extension === 'xlsx') {
      return <IconExcel />;
    }
    if (extension === 'png' || extension === 'jpg' || extension === 'jpeg') {
      return <IconImage />;
    }
    if (
      extension === 'mp3' ||
      extension === 'wav' ||
      extension === 'ogg' ||
      extension === 'aac' ||
      extension === 'flac' ||
      extension === 'wma' ||
      extension === 'mpga'
    ) {
      return <IconAudio />;
    }
    return null;
  };

  const handleOpenOrDownload = async (action: 'open' | 'download') => {
    let uri: string | undefined;
    if (data?.uri) {
      uri = data?.uri;
    } else if (data?.id) {
      setLoading(true);
      await Download(data.id)
        .then((response) => {
          const blob = new Blob([response], { type: data.type });
          uri = window.URL.createObjectURL(blob);
        })
        .finally(() => setLoading(false));
    }
    if (!uri) return;

    const link = document.createElement('a');

    link.href = uri;
    if (action === 'download') link.setAttribute('download', data?.name ?? 'arquivo');
    else link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.referrerPolicy = 'no-referrer';

    link.click();
  };

  return (
    <Container>
      <ItemAttachment>
        <div className="Img">{getIcon()}</div>
        <Tooltip disableInteractive title={data?.name} placement="bottom" arrow>
          <p>{data?.name}</p>
        </Tooltip>
        <div className="actions">
          {!options?.disableView && (
            <WrapperIcon title="Visualizar">
              <IconButton className="Icons" onClick={() => handleOpenOrDownload('open')}>
                <IconView style={{ fill: theme.colors.tertiary_500 }} />
              </IconButton>
            </WrapperIcon>
          )}
          {!options?.disableDownload && (
            <WrapperIcon title="Download">
              <IconButton className="Icons" onClick={() => handleOpenOrDownload('download')}>
                <FileDownloadOutlined style={{ fill: theme.colors.tertiary_500 }} />
              </IconButton>
            </WrapperIcon>
          )}
          {!options?.disableDelete && (
            <WrapperIcon title="Remover" color="error">
              <IconButton className="Icons" color="error" onClick={onDelete}>
                <Delete />
              </IconButton>
            </WrapperIcon>
          )}
        </div>
      </ItemAttachment>
    </Container>
  );
}
